import TaskContentTypes from 'lib/common/types/TaskContentTypes';

import TaskContentToKeyMap from '../constants/TaskContentToKeyMap';
import { TTaskAction, TaskAction } from '../constants/taskAction';
import { TAnyTask } from '../types/ContactContext';
import { TSetTaskContentOptions, TSetTaskContentTaskId, TSetTaskContentValue } from '../types/SetTaskContent';

export default function useSetTaskContent({
  getTasks,
  setTask,
}: {
  getTasks: () => TAnyTask[];
  setTask: ({ task, action }: { task: TAnyTask; action: TTaskAction }) => void;
}) {
  return (
    taskId: TSetTaskContentTaskId,
    type: TaskContentTypes,
    content: TSetTaskContentValue,
    { replace }: TSetTaskContentOptions = { replace: false }
  ) => {
    if (!taskId) {
      return;
    }

    const newTasks = [...getTasks()];
    const taskIndex = newTasks.findIndex((task) => task.taskId === taskId);

    if (taskIndex === -1) {
      return;
    }

    const originalContent = newTasks[taskIndex][TaskContentToKeyMap[type]];

    const updatedTaskContent = !replace && typeof content === 'object' ? { ...originalContent, ...content } : content;

    const updatedTask = {
      ...newTasks[taskIndex],
      [TaskContentToKeyMap[type]]: updatedTaskContent,
    };

    setTask({ task: updatedTask, action: TaskAction.UPDATE });
  };
}
